import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/filter";
import "rxjs/add/observable/of";
import { Subject } from "rxjs/Subject";
import { Spell } from "../../models/spell";
import { AngularFireDatabase } from "angularfire2/database";
import { Store } from "../../../store";

export const compareFn = (a: Spell, b: Spell): number => {
  if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
    return 1;
  }
  if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
    return-1;
  }
  return 0;
};

@Injectable()
export class SpellsService {
  constructor(private store: Store, private db: AngularFireDatabase) {}

  spells$: Observable<Spell[]> = this.db
    .list("spells")
    .map(spells => spells.sort(compareFn))
    .do(next => this.store.set("spells", next));

  getSpell(key: string) {
    if (!key) {
      return Observable.of({});
    }

    return this.store
      .select<Spell[]>("spells")
      .filter(Boolean)
      .map(spells => spells.find((spell: Spell) => spell.$key === key));
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/spells/spells.service.ts